module.exports = __webpack_public_path__ + "d16bff6a9c9d9171a4284b7946c4f3f2.png";